<div class="collapsibleTile collapsibleTile--usp is-collapsible">
  <div
    [ngStyle]="{ cursor: actionCode ? 'default' : 'hand' }"
    [cypress]="'expand_actioncode'"
    (click)="toggleExpanded()"
    class="collapsibleTile__title"
    [class.is-active]="isTileExpanded"
  >
    <a
      *ngIf="!actionCode; else usedCode"
      [ngStyle]="{ cursor: actionCode ? 'default' : 'hand' }"
      class="link title"
    >
      {{ "VERIFY.ACTION_CODE_TITLE.NOT_USED" | translate }}
    </a>
    <ng-template #usedCode>
      <a
        class="link title"
        [ngStyle]="{ cursor: actionCode ? 'default' : 'hand' }"
      >
        {{ "VERIFY.ACTION_CODE_TITLE.USED" | translate }}
      </a>
    </ng-template>
  </div>
  <div class="collapsibleTile__body" [class.is-expanded]="isTileExpanded">
    <div class="collapsibleTile__content" *ngIf="isTileExpanded">
      <section *ngIf="!actionCode" class="actionCode__body animated fadeIn">
        <input
          type="text"
          forceUppercase
          maxlength="40"
          class="textInput textInput--fullWidth"
          [(ngModel)]="actionCodeInput"
        />
        <button
          class="button"
          [cypress]="'validate_actioncode'"
          (click)="validateActionCode()"
        >
          {{ "BUTTON.VERIFY" | translate }}
        </button>
      </section>
      <section>
        <div
          *ngIf="loading; else showActionCode"
          class="mt-2 basicLoader"
        ></div>
        <ng-template #showActionCode>
          <section class="animated pulse">
            <div
              *ngIf="actionCode"
              [cypress]="'actioncode_result'"
              class="grey__tile"
            >
              <div class="actionCode__content">
                <h5 class="headingXS">
                  <strong>
                    {{ "VERIFY.ACTION_CODE" | translate }} [
                    {{ actionCode.code }} ]
                  </strong>
                </h5>
                <p class="mt-2">{{ actionCode.description }}</p>
                <a
                  class="link"
                  [cypress]="'delete_actioncode'"
                  (click)="remove.emit()"
                >
                  {{ "BUTTON.DELETE" | translate }}
                </a>
              </div>
            </div>
          </section>
        </ng-template>
      </section>
    </div>
  </div>
</div>
